import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { Form, Col } from 'react-bootstrap';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';
import * as layerOps from '../../../api/Layers/layer-operations';

const LayerIndoorLevelField = ({ layer, layerSubType, geojsonProps }) => {
  if (LAYER_SUBTYPES.INDOOR !== layerSubType) return '';
  return (
    <Form.Row className="mt-3">
      <Col xs={12}>
        <Form.Group>
          <Form.Label>Indoor Level</Form.Label>
          <Form.Control
            as="select"
            name="indoorLevel"
            defaultValue={layerOps.getIndoorLevel(layer)}
          >
            <option value="">-</option>
            {map(geojsonProps, ({ name }) => {
              return (
                <option value={name} key={name}>
                  {name}
                </option>
              );
            })}
          </Form.Control>
        </Form.Group>
      </Col>
    </Form.Row>
  );
};

LayerIndoorLevelField.propTypes = {
  geojsonProps: PropTypes.array.isRequired,
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired
};

export default LayerIndoorLevelField;
